import React, {createRef, useContext, useEffect, useRef, useState} from "react";
import UserContext from "../common/UserContext";
import {GeneralContext, SelectedProductContext} from "./FSARequestLicenseContext";
import {
    continueKey,
    mainMessages,
    myCartKey,
    saveCart,
    exportCartKey,
    searchProductsKey,
    genericErrorTitleKey,
    contactUsHeaderKey,
    changeCannotSaveKey,
    FSAExceedBudgetKey,
    productNumberKey,
    descriptionKey,
    licenseTypeKey,
    assignQtyKey,
    startDateKey,
    endDateKey,
    hostIdKey, discountPercentageKey, costPerUnitKey, totalCostKey, qtyKey, FSAExceedBudgetOnLoadKey
} from "../../assets/text/MultilingualText";
import {SelectedProductsGrid} from "./SelectProducts/SelectedProductsGrid";
import {Button} from "@progress/kendo-react-buttons";
import {Tooltip} from "@progress/kendo-react-tooltip";
import {fileExcelIcon} from "@progress/kendo-svg-icons";
import {useLocalization} from "@progress/kendo-react-intl";
import {SearchForm} from "./SelectProducts/SearchForm";
import {SearchedProductsGrid} from "./SelectProducts/SearchedProductsGrid";
import Alert from "../common/Alert";
import {OverdraftModal} from "./SelectProducts/OverdraftModal";
import moment from "moment";
import axios from "axios";
import config from "../../config";
import {exportExcel, formatCurrency} from "../common/utilities";
import {ExcelExport, ExcelExportColumn} from "@progress/kendo-react-excel-export";
import {addDays} from "@progress/kendo-date-math";

export default function SelectProducts(props) {

    const {
        siteLanguageDefault,
    } = useContext(UserContext);

    const {
        headerInfo,
        stepperItems,
        productNumKey,
        licenseStartDateKey,
        licenseEndDateKey,
        showGenericError,
        setShowGenericError,
        showSecondGenericError,
        setShowSecondGenericError,
        showOnloadExceedError,
        setShowOnloadExceedError,
        showCannotSaveError,
        setShowCannotSaveError,
        showOverdraftModal,
        setShowOverdraftModal,
        saveSelectionChanges,
        overdraftStepChange
    } = useContext(GeneralContext);

    const {
        selectedProducts,
        unsavedChanges,
    } = useContext(SelectedProductContext);

    const localization = useLocalization();

    const [displaySearchMessage, setDisplaySearchMessage] = useState(true);

    const alertRef = useRef()
    useEffect(() => {
        if (showSecondGenericError) {
            alertRef.current.focus();
        }
    }, [showSecondGenericError]);

    // kendo react excel export
    const [userExcelData, setUserExcelData] = useState([]);
    const [excelFileName] = useState("KSM_FSA_SELECTION_" + moment(new Date()).format('YYYYMMDD HHmmss'));

    const _exporter = createRef();
    const exportExcel = () => {
        if (_exporter.current) {
            _exporter.current.save();
        }
    };

    useEffect(() => {
        if (selectedProducts.length) {
            let updates = [];
            selectedProducts.forEach(product => {
                const license_type = product.license_type.filter(item => item.selected)[0]?.text;
                updates.push({
                    product_number: product[productNumKey],
                    description: product.description,
                    license_type: license_type,
                    quantity: product.quantity,
                    start_date: moment(product[licenseStartDateKey]).format('MM/DD/YYYY'),
                    end_date: moment(product[licenseEndDateKey]).format('MM/DD/YYYY'),
                    discount_percentage: product.discount_percentage.toString() + '%',
                    cost_per_unit: formatCurrency(product.price, product.currency_locale, product.currency_code),
                    total_cost: formatCurrency(product.total_cost, product.currency_locale, product.currency_code),
                });
            })
            setUserExcelData(updates);
        }
    }, [selectedProducts]);

    return (
        <>
            {selectedProducts.length > 0 && (
                <>
                    <div
                        className={'k-h5'}
                        style={{
                            marginBottom: '0.5rem'
                        }}
                    >
                        {localization.toLanguageString(myCartKey, mainMessages[siteLanguageDefault][myCartKey])}
                    </div>

                    <SelectedProductsGrid
                        showGenericError={showGenericError}
                        setShowGenericError={setShowGenericError}
                    />

                    <ExcelExport
                        data={userExcelData}
                        fileName={excelFileName}
                        ref={_exporter}
                    >
                        <ExcelExportColumn
                            field="product_number"
                            title={localization.toLanguageString(productNumberKey, mainMessages[siteLanguageDefault][productNumberKey])}
                        />
                        <ExcelExportColumn
                            field="description"
                            title={localization.toLanguageString(descriptionKey, mainMessages[siteLanguageDefault][descriptionKey])}
                        />
                        <ExcelExportColumn
                            field="quantity"
                            title={localization.toLanguageString(qtyKey, mainMessages[siteLanguageDefault][qtyKey])}
                        />
                        <ExcelExportColumn
                            field="license_type"
                            title={localization.toLanguageString(licenseTypeKey, mainMessages[siteLanguageDefault][licenseTypeKey])}
                        />
                        <ExcelExportColumn
                            field="start_date"
                            title={localization.toLanguageString(startDateKey, mainMessages[siteLanguageDefault][startDateKey])}
                        />
                        <ExcelExportColumn
                            field="end_date"
                            title={localization.toLanguageString(endDateKey, mainMessages[siteLanguageDefault][endDateKey])}
                        />
                        <ExcelExportColumn
                            field="discount_percentage"
                            title={localization.toLanguageString(discountPercentageKey, mainMessages[siteLanguageDefault][discountPercentageKey])}
                        />
                        <ExcelExportColumn
                            field="cost_per_unit"
                            title={localization.toLanguageString(costPerUnitKey, mainMessages[siteLanguageDefault][costPerUnitKey])}
                        />
                        <ExcelExportColumn
                            field="total_cost"
                            title={localization.toLanguageString(totalCostKey, mainMessages[siteLanguageDefault][totalCostKey])}
                        />
                    </ExcelExport>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'end',
                        gap: '0.5rem'
                    }}>
                        <div style={{
                            display: 'flex',
                            gap: '0.5rem'
                        }}>
                            <Button
                                themeColor={"primary"}
                                size={"large"}
                                fillMode={"outline"}
                                rounded={"small"}
                                disabled={
                                    unsavedChanges.size === 0 ||
                                    stepperItems[1].disabled
                                }
                                onClick={() => {
                                    saveSelectionChanges(0, false)
                                }}
                            >
                                {localization.toLanguageString(saveCart, mainMessages[siteLanguageDefault][saveCart])}
                            </Button>
                            <Button
                                themeColor={"primary"}
                                size={"large"}
                                fillMode={"solid"}
                                disabled={stepperItems[1].disabled}
                                onClick={() => {
                                    saveSelectionChanges(1, false)
                                }}
                            >
                                {localization.toLanguageString(continueKey, mainMessages[siteLanguageDefault][continueKey])}
                            </Button>
                        </div>
                        <div>
                            <Tooltip
                                anchorElement="target"
                                showCallout={true}
                                parentTitle={true}
                                openDelay={0}
                                position="top"
                            >
                                <Button
                                    title={localization.toLanguageString(exportCartKey, mainMessages[siteLanguageDefault][exportCartKey])}
                                    themeColor={"tertiary"}
                                    fillMode={"solid"}
                                    size={"large"}
                                    onClick={exportExcel}
                                    svgIcon={fileExcelIcon}
                                />
                            </Tooltip>
                        </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '0.5rem'
                    }}>
                        {showGenericError && (
                            <Alert
                                type={'error'}
                                showHandler={() => {
                                    setShowGenericError(false)
                                }}
                                title={localization.toLanguageString(genericErrorTitleKey, mainMessages[siteLanguageDefault][genericErrorTitleKey])}
                                message={localization.toLanguageString(contactUsHeaderKey, mainMessages[siteLanguageDefault][contactUsHeaderKey])}
                            />
                        )}

                        {showCannotSaveError && (
                            <Alert
                                type={'error'}
                                showHandler={() => {
                                    setShowCannotSaveError(false)
                                }}
                                title={localization.toLanguageString(changeCannotSaveKey, mainMessages[siteLanguageDefault][changeCannotSaveKey])}
                                message={localization.toLanguageString(FSAExceedBudgetKey, mainMessages[siteLanguageDefault][FSAExceedBudgetKey])}
                            />
                        )}

                        {showOnloadExceedError && (
                            <div style={{
                                width: '52.625rem'
                            }}>
                                <Alert
                                    type={'error'}
                                    showHandler={() => {
                                        setShowOnloadExceedError(false)
                                    }}
                                    title={localization.toLanguageString(changeCannotSaveKey, mainMessages[siteLanguageDefault][changeCannotSaveKey])}
                                    message={localization.toLanguageString(FSAExceedBudgetOnLoadKey, mainMessages[siteLanguageDefault][FSAExceedBudgetOnLoadKey])}
                                />
                            </div>
                        )}

                    </div>

                    {showOverdraftModal && (
                        <OverdraftModal
                            setShowModal={setShowOverdraftModal}
                            confirmationAction={() => {
                                saveSelectionChanges(overdraftStepChange, true)
                            }}
                        />
                    )}

                    <div className={'k-hr'}/>
                </>
            )}

            <div
                className={'k-h5'}
            >
                {localization.toLanguageString(searchProductsKey, mainMessages[siteLanguageDefault][searchProductsKey])}
            </div>

            <SearchForm
                setDisplaySearchMessage={setDisplaySearchMessage}
            />

            <SearchedProductsGrid
                displaySearchMessage={displaySearchMessage}
            />

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '0.5rem'
                }}
                tabIndex={0}
                ref={alertRef}
            >
                {showSecondGenericError && (
                    <Alert
                        type={'error'}
                        showHandler={() => {
                            setShowSecondGenericError(false)
                        }}
                        title={localization.toLanguageString(genericErrorTitleKey, mainMessages[siteLanguageDefault][genericErrorTitleKey])}
                        message={localization.toLanguageString(contactUsHeaderKey, mainMessages[siteLanguageDefault][contactUsHeaderKey])}
                    />
                )}
            </div>

            <div style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '1.875rem'
            }}>
                <div>
                    {headerInfo.legal_disclosure}
                </div>
            </div>
        </>
    )
}